import { render, staticRenderFns } from "./shopExpress.vue?vue&type=template&id=6e226334&"
import script from "./shopExpress.vue?vue&type=script&lang=js&"
export * from "./shopExpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports